<template>
  <el-row class="brand-bar" align="middle" justify="space-between" role="banner">
    <el-space direction="vertical" alignment="start" class="brand-text">
      <div class="name">Bridging Gaps In Research</div>
      <div class="tag">Empowering Research. Driving Innovation. Creating Impact.</div>
    </el-space>
    <el-avatar class="logo" shape="square" :size="100" :src="logoImg" alt="Company logo" />
  </el-row>
</template>

<script>
import logoImg from '@/assets/BGIR_Logo.webp'

export default {
  name: 'HeaderBar',
  data() {
    return { logoImg }
  }
}
</script>

<style scoped>
.brand-bar {
  width: 100%;
  min-height: 80px;
  background: linear-gradient(90deg, #065345 0%, #003831 55%, #0b6a59 100%);
  box-shadow: 0 14px 44px rgba(0,0,0,0.10);
  padding: 12px 16px;
  box-sizing: border-box;
  color: #fffbf5;
}

.brand-text { gap: 2px; }
.logo { box-shadow: 0 10px 28px rgba(0,0,0,0.12); border-radius: 0; background: #fff;  }
.name { font-size: 1.35rem; font-weight: 900; color: #fffbf5; }
.tag  { font-size: 1rem; color: rgba(255,255,255,0.94); }
</style>
